// Constants
export const SET_TOKEN = 'SET_TOKEN';

export interface Actions {
  SET_TOKEN: {
    type: typeof SET_TOKEN;
    payload: string | null;
  };
}

// Action Creators
export const actionCreators = {
  setToken(token: string): Actions[typeof SET_TOKEN] {
    return {
      payload: token,
      type: SET_TOKEN
    };
  },

  resetToken(): Actions[typeof SET_TOKEN] {
    return {
      payload: null,
      type: SET_TOKEN
    };
  }
};



// WEBPACK FOOTER //
// ./src/redux/session/actions.ts